// Sasquatch Cards Animimation
let playOptions = "restart complete complete reset";
let startString = "top 50%";
gsap.registerPlugin(ScrollTrigger);

let tl = gsap.timeline({
    scrollTrigger: {
        trigger: ".sasquatch-cards",
        toggleActions: playOptions,
        start: "top bottom",
        end: "bottom top",
        // markers: true,
    }
})
tl.from(".sasquatch-cards .categories-grid__img", {
    opacity: 0,
    top: "500px",
    stagger: 0.2
})

let tg = gsap.timeline({
    scrollTrigger: {
        trigger: ".sasquatch-cards-two",
        toggleActions: playOptions,
        start: 'top bottom',
        end: "bottom top",
        // markers: true,
    }
})
tg.from(".sasquatch-cards-two .categories-grid__img", {
    opacity: 0,
    top: "500px",
    stagger: 0.2
})

let th = gsap.timeline({
    scrollTrigger: {
        trigger: ".sasquatch-cards-three",
        toggleActions: playOptions,
        start: "top bottom",
        end: "bottom top",
        // markers: true,
    }
})
th.from(".sasquatch-cards-three .categories-grid__img", {
    opacity: 0,
    top: "500px",
    stagger: 0.2
})

let sl1 = gsap.timeline({
    scrollTrigger: {
        trigger: ".slapped-cards",
        toggleActions: playOptions,
        start: "top bottom",
        end: "bottom top",
        // markers: true,
    }
})
sl1.from(".slapped-cards .categories-grid__img-1", {
    opacity: 0,
    top: "-500px",
    stagger: 0.6
})
sl1.from(".slapped-cards .categories-grid__img-2", {
    opacity: 0,
    top: "-500px",
    stagger: 0.5
})
sl1.from(".slapped-cards .categories-grid__img-3", {
    opacity: 0,
    top: "500px",
    stagger: 0.5
})
sl1.from(".slapped-cards .categories-grid__img-4", {
    opacity: 0,
    top: "500px",
    stagger: 0.5
})

let vd = gsap.timeline({
    scrollTrigger: {
        trigger: ".video-sasquatch-container",
        toggleActions: playOptions,
        start: "top bottom",
        end: "bottom top",
        // markers: true,
    }
})
vd.from(".video-sasquatch", {
    opacity: 0,
    left: "-400px",
    stagger: 0.2
})

let st = gsap.timeline({
    scrollTrigger: {
        trigger: ".quick-step--cards",
        toggleActions: playOptions,
        start: "top bottom",
        end: "bottom top",
        // markers: true,
    }
})
st.from(".quick-step--cards .quick-step-grid__wrap", {
    opacity: 0,
    top: "500px",
    stagger: 0.1
})

let ot = gsap.timeline({
    scrollTrigger: {
        trigger: ".other-products__item",
        toggleActions: playOptions,
        start: "top bottom",
        end: "bottom top",
        // markers: true,
    }
})
ot.from(".other-products__item .card--product", {
    opacity: 0,
    top: "500px",
    stagger: 0.2
})